<template>
    <div class="treatment-info">
        <van-collapse v-model="activeName" accordion>
            <van-collapse-item :name="index" v-for="(item, index) in listData" :key="index">
                <template #title>
                    <div>{{ formatTitle(index) }}</div>
                    <div class="slot-title-box" v-if="index !== activeName">
                        疗程评价：
                        <div class="slot-title-info">
                            {{ findName(item.effectFlag, 1) }}
                        </div>
                    </div>
                </template>
                <CollapseInfo :therapeuticEvaluation="item" />
            </van-collapse-item>
        </van-collapse>
    </div>
</template>
<script>
import CollapseInfo from "./collapseInfo.vue";
import { formatNum } from "@/utils/baseFormat";

export default {
    name: "TreatmentInfo",
    props: {
        listData: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        CollapseInfo,
    },
    data() {
        return {
            activeName: 0,
        };
    },
    computed: {
        evaluateRadioList() {
            return [
                { key: 1, value: "有效" },
                { key: 3, value: "无效" },
                { key: 2, value: "待观察" },
            ];
        },
        arrangeList() {
            return [
                { key: 1, value: "未反馈" },
                { key: 2, value: "正常随访" },
                { key: 3, value: "停止服药(已康复)" },
                { key: 4, value: "服药中断(疫情中断)" },
                { key: 5, value: "服药中断(服用其他药物参与/其他治疗药物)" },
                { key: 6, value: "服药中断(身体不适)" },
            ];
        },
        improveList() {
            return [
                { key: 1, value: "是" },
                { key: 0, value: "否" },
            ];
        },
        medicalAdvice() {
            return [
                { key: 1, value: "偶尔漏服" },
                { key: 2, value: "经常漏服" },
                { key: 3, value: "偶尔吃药" },
                { key: 4, value: "严格服药" },
                { key: 5, value: "未服药" },
                { key: 6, value: "选择性服药" },
                { key: 7, value: "未反馈" },
            ];
        },
    },
    methods: {
        formatTitle(index) {
            return `第${formatNum(this.listData.length - index)}疗程`;
        },
        findName(value, type) {
            const obj = {
                1: "evaluateRadioList",
                2: "arrangeList",
                3: "improveList",
                4: "medicalAdvice",
            };
            let findObj = this[obj[type]].find((item) => item.key === value);
            return findObj ? findObj.value : "-";
        },
    },
};
</script>
<style lang="scss" scoped>
.treatment-info {
    :deep(.van-collapse) {
        background: #f2f2f2;

        .van-collapse-item--border::after {
            display: none;
        }

        .van-collapse-item {
            border-radius: 4px;
            overflow: hidden;

            +.van-collapse-item {
                margin-top: 12px;
            }

            .van-cell:not(.van-field) {
                padding: 16px 15px;

                &.van-collapse-item__title--expanded {
                    .van-icon {
                        transform: rotate(-180deg) translateZ(0) !important;
                    }
                }

                &::after {
                    display: none !important;
                }

                .van-cell__title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333333;

                    .slot-title-box {
                        font-size: 14px;
                        color: #666666;
                        display: flex;

                        .slot-title-info {
                            margin-left: 15px;
                            color: #333333;
                        }
                    }

                    span {
                        position: relative;

                        &::after {
                            position: absolute;
                            content: "";
                            width: 100%;
                            bottom: 8px;
                            left: 0;
                            height: 3px;
                            background: linear-gradient(90deg,
                                    #0082ef 0%,
                                    rgba(0, 130, 239, 0) 100%);
                            border-radius: 3px;
                        }
                    }
                }

                .van-icon {
                    height: 20px;
                    width: 20px;
                    position: relative;
                    transition: transform 0.3s;

                    &::before {
                        content: "";
                        transition: transform 0.3s;
                        height: 20px;
                        width: 20px;
                        transform: rotate(180deg) translateZ(0);
                        background: url("~@/assets/images/moreEffective/arrows.png") center/cover no-repeat;
                    }
                }
            }

            .van-collapse-item__content {
                padding: 0;

                .collapse-info-box {
                    .van-cell {
                        padding: 9px 15px;

                        &::after {
                            display: none;
                        }

                        .van-field__label {
                            font-size: 14px;
                            color: #666666;
                            width: auto;
                        }
                    }

                    .van-radio {
                        .van-radio__label {
                            font-size: 14px;
                            color: #888888;
                            margin-left: 5px;
                        }

                        .van-radio__icon--checked {
                            .van-icon {
                                border: 1px solid #4991fc;
                                background-color: #fff;
                                position: relative;

                                &::before {
                                    position: absolute;
                                    content: "";
                                    left: 50%;
                                    top: 50%;
                                    width: 75%;
                                    height: 75%;
                                    border-radius: 50%;
                                    background: #4991fc;
                                    transform: translate(-50%, -50%);
                                }
                            }
                        }
                    }

                    .save-box {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 15px;

                        .van-button {
                            font-size: 14px;
                            border-radius: 4px;
                            padding: 6px 20px;
                            width: auto;
                            height: auto;

                            &+.van-button {
                                margin-left: 30px;
                            }
                        }
                    }

                    .form-info-box {
                        .form-item {
                            padding: 9px 15px;
                            display: flex;
                            align-items: flex-start;

                            .form-lable {
                                padding-right: 14px;
                                color: #666666;
                                font-size: 14px;
                            }

                            .form-title {
                                flex: 1;
                                font-size: 14px;
                                color: #333333;
                                white-space: pre-wrap;
                                word-break: break-all;
                            }
                        }
                    }
                }

                .collapse-info-box-disabled {}
            }
        }
    }
}
</style>
